// removed by extract-text-webpack-plugin
module.exports = {"block":"AppRatingBar__block-2rz3w","star":"AppRatingBar__star-2p8Nw","successText":"AppRatingBar__successText-1aDCg"};